import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import { withStyles } from '@material-ui/core/styles';

const StyledTabs = withStyles((theme) => ({
  root: {
    borderBottom: '1px solid #E0E0E0',
    // minHeight: 60,
  },
  indicator: {
    color: 'red',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    '& > span': {
      width: '100%',
      backgroundColor: theme.palette.primary.main,
    },
  },
}))((props) => {
  return <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />;
});

export default StyledTabs;
